import React from "react";
import config from "../../../config/config";
import Anchor from "../../HTMLEntities/Anchor";
import {
    AIRCLogo,
    FooterBottomInfoSection,
    FooterContributeFollowUsSection,
    FooterDetailSection,
    FooterFBIcon,
    FooterInfoGreySection,
    FooterInstagramIcon,
    FooterLogo,
    FooterNaukriCompany,
    FooterSectionLabel,
    FooterSocialLinks,
    FooterYouTubeIcon,
    MailIcon,
    WriteReviewIcon,
} from "./FooterStyled";
import PropTypes from "prop-types";

const FooterCommonSection = () => {
    return (
        <>
            <FooterDetailSection>
                <FooterSectionLabel>Contribute</FooterSectionLabel>
                <FooterInfoGreySection>
                    <WriteReviewIcon />
                    <Anchor
                        linkLabel={"Write Review"}
                        linkHref={"https://shiksha.com/studyabroad/college-review-rating"}
                        disabledExternalValidation={true}
                        displayStyle={{
                            mobile: {
                                width: "auto",
                                maxWidth: "100%",
                            },
                            laptop: {
                                width: "auto",
                                maxWidth: "100%",
                            },
                        }}
                    />
                </FooterInfoGreySection>
            </FooterDetailSection>
            <FooterDetailSection>
                <FooterSectionLabel>Follow Us</FooterSectionLabel>
                <FooterSocialLinks>
                    <Anchor
                        linkHref={"https://www.facebook.com/studyabroad.shiksha"}
                        target={"_blank"}
                        rel="noopener noreferrer"
                        alt="facebook"
                        title="facebook"
                        disabledExternalValidation={true}
                    >
                        <FooterFBIcon />
                    </Anchor>
                    <Anchor
                        linkHref={"https://www.youtube.com/channel/UCBM1K45nZFcDPDNFkweclNw"}
                        target={"_blank"}
                        rel="noopener noreferrer"
                        alt="youtube"
                        title="youtube"
                        disabledExternalValidation={true}
                    >
                        <FooterYouTubeIcon />
                    </Anchor>
                    <Anchor
                        linkHref={"https://www.instagram.com/shikshastudyabroad/"}
                        target={"_blank"}
                        rel="noopener noreferrer"
                        alt="instagram"
                        title="instagram"
                        disabledExternalValidation={true}
                    >
                        <FooterInstagramIcon />
                    </Anchor>
                </FooterSocialLinks>
            </FooterDetailSection>
        </>
    );
};

const FooterBottomInfoWidget = (props) => {
    const {isMobile} = props;
    return (
        <FooterBottomInfoSection>
            <FooterDetailSection aircStyle={true}>
                <a href={`${config.SHIKSHA_STUDYABROAD_HOME}`}>
                    <FooterLogo />
                </a>
                {isMobile && (
                    <a
                        href="https://www.airc-education.org/airc-certified-agencies"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <AIRCLogo />
                        <span>
                            AIRC - Certification for <br />
                            recruitment services
                        </span>
                    </a>
                )}
            </FooterDetailSection>
            <FooterDetailSection>
                <FooterSectionLabel>Get in touch</FooterSectionLabel>
                <FooterInfoGreySection>
                    <MailIcon />
                    <Anchor
                        linkLabel={"studyabroad@shiksha.com"}
                        linkHref={"mailto:studyabroad@shiksha.com"}
                        displayStyle={{
                            mobile: {
                                width: "auto",
                                maxWidth: "100%",
                            },
                            laptop: {
                                width: "auto",
                                maxWidth: "100%",
                            },
                        }}
                    />
                </FooterInfoGreySection>
            </FooterDetailSection>

            {isMobile === true ? (
                <FooterContributeFollowUsSection>
                    <FooterCommonSection />
                </FooterContributeFollowUsSection>
            ) : (
                <FooterCommonSection />
            )}
            <FooterDetailSection>
                <FooterNaukriCompany>
                    A <i /> Group Company
                </FooterNaukriCompany>
            </FooterDetailSection>
        </FooterBottomInfoSection>
    );
};
FooterBottomInfoWidget.propTypes = {
    isMobile: PropTypes.bool,
};

export default FooterBottomInfoWidget;
